export default __webpack_public_path__ + "static/media/digital_wireframe_3.4892c0b9.jpg";